/*
 *
 * ZohoVerify reducer
 *
 */
import produce from 'immer';
import { VERIFY_ZOHO } from './constants';

export const initialState = {
  isVerify: true,
  error: false,
};

/* eslint-disable default-case, no-param-reassign */
const zohoVerifyReducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case VERIFY_ZOHO.START:
        draft.isVerify = true;
        draft.error = false;
        break;

      case VERIFY_ZOHO.SUCCESS:
        draft.isVerify = false;
        draft.error = false;
        break;

      case VERIFY_ZOHO.ERROR:
        draft.isVerify = false;
        draft.error = true;
        break;
    }
  });
};

export default zohoVerifyReducer;
